import React, { useEffect, useRef, useState } from "react";
import { api } from "../../../lib/api";
import { imgSrc } from "../../../lib/content";
import { toast } from "sonner";
import { Upload, Trash2, Plus } from "lucide-react";
import { uploadImage } from "./fields";

export default function GalleryArchiveEditor() {
  const [items, setItems] = useState([]);
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const load = () => api.get("/gallery").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async (u) => {
    if (!u) return;
    try { await api.post("/gallery", { url: u }); setUrl(""); toast.success("Foto aggiunta"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  const onFile = async (files) => {
    setBusy(true);
    for (const f of Array.from(files)) {
      try { await add(await uploadImage(f)); } catch (e) { toast.error(`${f.name}: errore upload`); }
    }
    setBusy(false);
    if (input.current) input.current.value = "";
  };
  const remove = async (id) => {
    if (!window.confirm("Togliere questa foto dall'archivio?")) return;
    await api.delete(`/gallery/${id}`); load();
  };

  return (
    <div>
      <div className="flex flex-wrap gap-3 items-end mb-6">
        <input value={url} onChange={e=>setUrl(e.target.value)} placeholder="https://link-immagine..." className="input-dark flex-1 min-w-[220px] font-mono text-xs" data-testid="archive-url"/>
        <button onClick={()=>add(url.trim())} className="btn-ghost !py-2 !px-3 text-[10px] flex items-center gap-1" data-testid="archive-add-url"><Plus className="w-3 h-3"/>AGGIUNGI LINK</button>
        <input ref={input} type="file" accept="image/*" multiple className="hidden" onChange={e=>onFile(e.target.files)} data-testid="archive-file"/>
        <button onClick={()=>input.current.click()} disabled={busy} className="btn-primary !py-2 !px-3 text-[10px] flex items-center gap-1" data-testid="archive-upload"><Upload className="w-3 h-3"/>{busy ? "..." : "CARICA FOTO"}</button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {items.map(it => (
          <div key={it.id} className="relative group border border-neutral-800" data-testid={`archive-item-${it.id}`}>
            <img src={imgSrc(it.url)} alt="" className="w-full aspect-square object-cover"/>
            <button onClick={()=>remove(it.id)} className="absolute top-1 right-1 bg-black/80 text-alert p-2" aria-label="Elimina" data-testid={`archive-delete-${it.id}`}><Trash2 className="w-4 h-4"/></button>
          </div>
        ))}
      </div>
    </div>
  );
}
